import { render, staticRenderFns } from "./CorrectTextAnswers.vue?vue&type=template&id=1b2758aa&scoped=true&"
import script from "./CorrectTextAnswers.vue?vue&type=script&lang=ts&"
export * from "./CorrectTextAnswers.vue?vue&type=script&lang=ts&"
import style0 from "./CorrectTextAnswers.vue?vue&type=style&index=0&id=1b2758aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2758aa",
  null
  
)

export default component.exports